import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assets/fonts/Gotham-Font/GothamBold.ttf";
import "./assets/fonts/Gotham-Font/GothamBoldItalic.ttf";
import "./assets/fonts/Gotham-Font/GothamBookItalic.ttf";
import "./assets/fonts/Gotham-Font/GothamLight.ttf";
import "./assets/fonts/Gotham-Font/GothamLightItalic.ttf";
import "./assets/fonts/Gotham-Font/GothamMedium.ttf";
import "./assets/fonts/Gotham-Font/GothamMedium_1.ttf";
import "./assets/fonts/Gotham-Font/GothamMediumItalic.ttf";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
